"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _FiltersStyled = require("./Filters-styled.js");
var _FilterGroup = _interopRequireDefault(require("../FilterGroup"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _helper = require("../../utils/helper");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Filters = function Filters(_ref) {
  var filters = _ref.filters,
    onChangeFilter = _ref.onChangeFilter,
    onFilterItemClick = _ref.onFilterItemClick,
    onFilterItemOptionClick = _ref.onFilterItemOptionClick,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FiltersStyled.StyledFilters, {
    minimal: true,
    style: _objectSpread(_objectSpread({}, style), {}, {
      maxWidth: "30rem"
    })
  }, /*#__PURE__*/_react.default.createElement(_FiltersStyled.StyledFiltersHeader, null, "Filters"), filters && filters.groups.allIds.map(function (id) {
    return /*#__PURE__*/_react.default.createElement(_FilterGroup.default, {
      key: filters.groups.byId[id].id,
      group: _objectSpread(_objectSpread({}, filters.groups.byId[id]), {}, {
        items: (0, _helper.getFilterGroupItems)({
          items: filters.items,
          groupId: id
        })
      }),
      filters: filters,
      onChangeFilter: onChangeFilter,
      onFilterItemClick: onFilterItemClick,
      onFilterItemOptionClick: onFilterItemOptionClick
    });
  })));
};
Filters.propTypes = {
  filters: _propTypes.default.shape({
    groups: _propTypes.default.shape({
      byId: _propTypes.default.shape({
        id: _propTypes.default.string,
        title: _propTypes.default.string,
        state: _propTypes.default.string
      }),
      allIds: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
    }),
    items: _propTypes.default.shape({
      byId: _propTypes.default.shape({
        id: _propTypes.default.string,
        title: _propTypes.default.string,
        state: _propTypes.default.string,
        group: _propTypes.default.string
      }),
      allIds: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
    })
  }).isRequired,
  onChangeFilter: _propTypes.default.func
};
var _default = Filters;
exports.default = _default;